

import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function TermsAndConditionsInfo({ section }) {

  return (
    <Typography variant="body2" align="center" fontSize='0.7rem' sx={{ color: 'text.secondary', mt: 3 }}>
      By logging in or signing up, you agree to our &nbsp;
      <RouterLink underline="always" color="text.primary" to={`/${section}/auth/terms-and-conditions`}>
        Terms & Conditions and Privacy Policy
      </RouterLink>.
      <br />
      Please read these documents carefully. They contain important information about your rights and obligations, as well as limitations and exclusions that may apply to you.
    </Typography>
  )
}